// extracted by mini-css-extract-plugin
export var active = "_cb-2";
export var recordingDot = "_cb-1";
export var recordingIndicator = "_cb-0";